function topic_hillslope_alarm(){
	var alert_container = {
		rain: {},
		debris: {},
		stage: {}
	};
	var alert_sum = {
		rain: {total: 0, red: 0, yellow: 0, normal: 0, grey: 0},
		debris: {total: 0, red: 0, yellow: 0, normal: 0},
		stage: {total: 0, red: 0, purple: 0, yellow: 0, normal: 0},
		jiufen: {total: 0, red: 0, normal: 0},
		flash: {total: 29, red: 0, yellow: 0, list: {} }
	};

	raw_data["debris_basic"] ??= ajax_call("geojson/swcb/SWCB_Debris.geojson")
	var debris_data = raw_data["debris_basic"], debris_alert = raw_data["土石流潛勢溪流"], debris_alert_object = {}
	if (debris_alert != null && debris_alert.status != 'fail') {
		if (debris_alert.errorMessage != undefined) {
			debris_data.features.forEach(function(element){
				if (alert_container.debris[element.properties.Town01] == undefined) {
					alert_container.debris[element.properties.Town01] = {red: 0, yellow: 0, normal: 0};
				}
				alert_container.debris[element.properties.Town01]["normal"] += 1;
				alert_sum.debris["normal"] += 1;
			});
			alert_sum.debris["total"] += 1;
		} else {
			debris_alert.forEach(function(element){
				if (element.county == "新北市") {
					debris_alert_object[element.debrisNo] = element;
				}
			});
			debris_data.features.forEach(function(element){
				if (alert_container.debris[element.properties.Town01] == undefined) {
					alert_container.debris[element.properties.Town01] = {red: 0, yellow: 0, normal: 0};
				}
				if (debris_alert_object[element.properties.Debrisno] == undefined) {
					alert_container.debris[element.properties.Town01]["normal"] += 1;
					alert_sum.debris["normal"] += 1;
				} else{
					if (element.alert_date_yellow != "") {
						alert_sum.debris["yellow"] += 1;
						alert_container.debris[element.properties.Town01]["yellow"] += 1;
					} else {
						alert_sum.debris["red"] += 1;
						alert_container.debris[element.properties.Town01]["red"] += 1;
					} 
				}
				alert_sum.debris["total"] += 1;
			});
		};
	} else {
		debris_data.features.forEach(function(element){
			if (alert_container.debris[element.properties.Town01] == undefined) {
				alert_container.debris[element.properties.Town01] = {red: 0, yellow: 0, normal: 0};
			}
			alert_container.debris[element.properties.Town01]["normal"] += 1;
			alert_sum.debris["normal"] += 1;
		});
		alert_sum.debris["total"] += 1;
	};

	for (var category in alert_sum) {
		for (var level in alert_sum[category]) {
			$("." + category + "-" + level + "-bar").css("width", (alert_sum[category][level] / alert_sum[category]["total"])*100 + "%")	
		}
	}

	var jiufen_data = raw_data["九份地滑監測"], jiufen_tbody_data = [], jiufen_object = {};
	if (jiufen_data) {
		jiufen_data.features.forEach(function(element){
			var this_properties = element.properties, status;
			alert_sum.jiufen["total"] += 1;
			switch(true){
				case (this_properties.w_level > this_properties.threshold):
					alert_sum.jiufen["red"] += 1;
					status = '<span class="badge badge-danger">達警戒值</span>';
					break;
				default:
					alert_sum.jiufen["normal"] += 1;
					status = '<span class="badge badge-success">未達警戒</span>';
			}
			jiufen_tbody_data.push([this_properties.stn_name, this_properties.timestamp, this_properties.w_level.toFixed(0) + "m", this_properties.threshold + "m", status]);
			jiufen_object[this_properties.stn_name] = {
				"coor": [element.geometry.coordinates[1], element.geometry.coordinates[0]],
				"w_level": this_properties.w_level
			}
		});
	} else {
		toast_open("九份地滑監測資料介接異常！");
	};

	$("#hillslope-cardbody").html(
		slider_card_component_create({
			"cardhead": "土石流示警統計資訊",
			"cardbody": 
				'<div class="col-4 text-center">'+
					'<h5>紅色' + alert_sum.debris["red"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-red debris-red-bar" role="progressbar" aria-valuenow="' + (alert_sum.debris["red"]/alert_sum.debris["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>黃色' + alert_sum.debris["yellow"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-yellow debris-yellow-bar" role="progressbar" aria-valuenow="' + (alert_sum.debris["yellow"]/alert_sum.debris["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-4 text-center">'+
					'<h5>未達' + alert_sum.debris["normal"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-green debris-normal-bar" role="progressbar" aria-valuenow="' + (alert_sum.debris["normal"]/alert_sum.debris["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="debris_sta" class="col-12 h-280"></div>'
		}) +
		slider_card_component_create({
			"cardhead": "地滑示警統計資訊(九份)",
			"cardbody": 
				'<div class="col-6 text-center">'+
					'<h5>警戒' + alert_sum.jiufen["red"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-red jiufen-red-bar" role="progressbar" aria-valuenow="' + (alert_sum.jiufen["red"]/alert_sum.jiufen["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>未達' + alert_sum.jiufen["normal"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-green jiufen-normal-bar" role="progressbar" aria-valuenow="' + (alert_sum.jiufen["normal"]/alert_sum.jiufen["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-12 mb-3" id="jiufen_table">'+
					'<table class="table table-sm text-center" width="100%">' +
						'<thead class="thead-dark">' +
							'<tr>' +
								'<th>站名</th>' +
								'<th>時間</th>' +
								'<th>水位高</th>' +
								'<th>警戒值</th>' +
								'<th>狀態</th>' +
							'</tr>' +
						'</thead>' +
						'<tbody class="p-cursor"></tbody>' +
					'</table>'+
				'</div>'+
				'<div id="jiufen_series" class="col-12 h-380"></div>'
		})
	);

	$('#jiufen_table table').DataTable({
        "data": jiufen_tbody_data,
        "deferRender": true,
        "order": [[ 1, "desc" ]],
        "searching": true
    });

    $("#jiufen_table tbody").on("click", "tr", function(){
        var coor_array = jiufen_object[$(this).find("td").eq(0).html()]["coor"];
        map.setView(coor_array, 18);
        jiufen_rain_undergroud_plot($(this).find("td").eq(0).html());
    });

	if (jiufen_data) {
		jiufen_rain_undergroud_plot("AOW-1");
	}
	function jiufen_rain_undergroud_plot(sensor_id){
		var jiufen_plot_setting = {
			"div": "jiufen_series",
			"series": {
				"label_name": ["雨量(mm)", "水位高(m)"],
				"series_name": ["觀測雨量", "地下水位"],
				"data": [[], []]
			},
			"title": sensor_id + "地下水位觀測與當地降雨趨勢對照圖"
		};
		var raindata_jiufen = ajax_call(publicPath + "/napi/obs/jiufen/rain"),
			underground_jiufen = ajax_call(publicPath + "/napi/obs/jiufen/waterlevel?station=" + sensor_id)
		raindata_jiufen.forEach(function(element, index){
			var time = time_sql_processing(element.timestamp)
			jiufen_plot_setting["series"]["data"][0].push([time, element.r_level])
			jiufen_plot_setting["series"]["data"][1].push([time, underground_jiufen[index].w_level])
		});
		jiufen_plot_setting["series"]["data"][0].reverse();
		jiufen_plot_setting["series"]["data"][1].reverse();
		highchart_two_panes_series_plot(jiufen_plot_setting);
	}

	stacked_percent_chart({
		div: "debris_sta",
		data: alert_container.debris,
		key_name: ["red", "yellow", "normal"],
		label: ["紅色", "黃色", "未達"],
		color: ['#e85a71', '#FFBC42', '#3ac569']
	});
}
